import LandingNavigation from './LandingNavigation.vue'

export default LandingNavigation
